import React from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
// import logo from "./logo.svg";
// import "./App.css";
import Home from "./pages/home";
import Others from "./pages/others";
import Computers from "./pages/computers";
import Apparel from "./pages/apparel";
import Gifts from "./pages/gifts";
import Brands from "./pages/brands";
import BrandDiscountCode from "./pages/branddiscountcode";
import CopyDiscountCode from "./pages/copydiscountcode";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/others" element={<Others />} />
          <Route path="/computers" element={<Computers />} />
          <Route path="/apparel" element={<Apparel />} />
          <Route path="/gifts" element={<Gifts />} />
          <Route path="/brands/dtc" element={<Brands category="dtc" />} />
          <Route
            path="/brands/walmart"
            element={<Brands category="walmart" />}
          />
          <Route path="/brands/amazon" element={<Brands category="amazon" />} />

          <Route path="/branddiscountcode" element={<BrandDiscountCode />} />

          <Route path="/copydiscountcode" element={<CopyDiscountCode />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
